module.exports = "<div ng-repeat=\"msg in messages\" class=\"notify\" aria-hidden=\"false\">\n    <div class=\"message {{msg.type}}\">\n\t\t<i class=\"material-icons\" ng-if=\"msg.type === 'error'\">error</i>\n\t\t<i class=\"material-icons\" ng-if=\"msg.type === 'warning'\">warning</i>\n\t\t<i class=\"material-icons\" ng-if=\"msg.type === 'success'\">check_circle</i>\n\t\t<i class=\"material-icons\" ng-if=\"msg.type === 'info'\">info</i>\n\t\t<div>{{ msg.title }}</div>\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/views/notify.html
// module id = 462
// module chunks = 0